
import {ENGINE} from './engine'
import {ready,setBackend,getBackend} from './globals'
import logger from '@kemtai/logger';



function _isBuggyAppleBrowser(): boolean {
    const ua = navigator.userAgent;
    const minBuggyVersion = 18.3;
    
    //console.log('User Agent:', ua);

    // Mozilla/5.0 (iPhone; CPU iPhone OS 18_6_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148
    const isIPhone = /iPhone OS/.test(ua);
    if (isIPhone) {
        const OSVersionMatch = ua.match(/iPhone OS (\d+)_(\d+)/);
        const VersionMajor = OSVersionMatch && OSVersionMatch.length > 1 ? parseInt(OSVersionMatch[1], 10) : 0;
        const VersionMinor = OSVersionMatch && OSVersionMatch.length > 2 ? parseInt(OSVersionMatch[2], 10) : 0;
        const versionNumber = VersionMajor + VersionMinor / 10;
        logger.message(`${versionNumber >= minBuggyVersion ? "🍎" : "🍏"} iPhone OS safari version ${versionNumber}`);
        return versionNumber >= minBuggyVersion; 
    }
    const isIPad = /iPad; CPU OS/.test(ua);
    if (isIPad) {
        const OSVersionMatch = ua.match(/iPad; CPU OS (\d+)_(\d+)/);
        const VersionMajor = OSVersionMatch && OSVersionMatch.length > 1 ? parseInt(OSVersionMatch[1], 10) : 0;
        const VersionMinor = OSVersionMatch && OSVersionMatch.length > 2 ? parseInt(OSVersionMatch[2], 10) : 0;
        const versionNumber = VersionMajor + VersionMinor / 10;
        logger.message(`${versionNumber >= minBuggyVersion ? "🍎" : "🍏"} iPad OS safari version ${versionNumber}`);
        return versionNumber >= minBuggyVersion; 
    }

    // Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/18.6 Safari/605.1.15
    const isMac = /Macintosh;/.test(ua);
    if (isMac) {
        const OSVersionMatch = ua.match(/Version\/(\d+)\.(\d+)/);
        const VersionMajor = OSVersionMatch && OSVersionMatch.length > 1 ? parseInt(OSVersionMatch[1], 10) : 0;
        const VersionMinor = OSVersionMatch && OSVersionMatch.length > 2 ? parseInt(OSVersionMatch[2], 10) : 0;
        const versionNumber = VersionMajor + VersionMinor / 10;
        logger.message(`${versionNumber >= minBuggyVersion ? "🍎" : "🍏"} MacOS safari version ${versionNumber}`);
        return versionNumber >= minBuggyVersion; 
    }
    return false;
}

const isBuggyAppleBrowser = _isBuggyAppleBrowser();
if (isBuggyAppleBrowser) {
    //console.log('🐞 Buggy Apple Browser');
    logger.event('tfjs-isBuggyAppleBrowser', {level:"webgl-log"});
}
const defaultBackendPriority: {[key: string]: number} = {
    'webgl':  isBuggyAppleBrowser ? 1 : 4,
    'webgpu': 3,
    'wasm':   2,
}

export function onWebGLContextLost() {
    defaultBackendPriority['webgl'] = 1;
}

export async function changeBackend(backend: string) {
    logger.event('tfjs-changeBackend', {
        backend: backend,
        level: 'webgl-log'
    });
    console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>> Changing TensorFlow.js backend to:', backend);
    (window as any)._kemtapi?.beforeContextRestart()

    ENGINE.reset();
    await setBackend(backend);
    await ready();
    // if (backend === 'wasm') {
    //     console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>> WASM threads count is:', getThreadsCount());
    // }
    (window as any)._kemtapi?.afterContextRestart()
    console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>> TensorFlow.js backend changed to:', getBackend());
    logger.event('tfjs-changeBackend-done', {
        backend: getBackend(),
        level: 'webgl-log'
    });
}

export async function resetBackend() {
    logger.event('tfjs-resetBackend', {
        backend: getBackend(),
        level: 'webgl-log'
    });

    (window as any)._kemtapi?.beforeContextRestart()

    logger.message('mini-tfjs: resetBackend - calling ENGINE.reset()');

    ENGINE.reset();
    await ready();


    logger.message('mini-tfjs: resetBackend - ENGINE.reset() - done' );
    
    logger.event('tfjs-resetBackend-done', {
        backend: getBackend(),
        level: 'webgl-log'
    });

    await (window as any)._kemtapi?.afterContextRestart()
}



export function backendPriority(backend: string) {
    logger.message(`mini-tfjs: backendPriority - backend: ${backend} ${defaultBackendPriority[backend]}`, {level:"webgl-log"});
    return defaultBackendPriority[backend] || 1
}